import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { CloudflareAiAccesses } from "./accesses.ts";
import { CloudflareAiComponents } from "./components.ts";
import { CloudflareAiIconUrl } from "./icon.ts";

// Rule filter values compile to regular expressions. Every requested group is
// a `policy` filterable, so an allow rule must match all of them. A request
// without a zone has an empty `zone`.
const CloudflareAiFilters = {
  account: { keys: ["name"] },
  zone: { keys: ["name"] },
  policy: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type CloudflareAiFilters = typeof CloudflareAiFilters;

export const CloudflareAiRegistration = Registration({
  accesses: CloudflareAiAccesses,
  category: "resource",
  components: CloudflareAiComponents,
  // A path here becomes a link in the product, so there's none until the
  // docs page exists.
  docs: {},
  filters: CloudflareAiFilters,
  itemKind: "Account",
  label: "Cloudflare (AI)",
  logoUrl: CloudflareAiIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "credential" }],
});

registerIntegration("cloudflare-ai", CloudflareAiRegistration);
